import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { BreadcrumbService } from "../ui-components/xn-breadcrumb/breadcrumb.service";
import { BreadcrumbStatus } from "../ui-components/xn-breadcrumb/type";

export interface CompletedSteps {
  step1?: boolean,
  step2?: boolean,
  step3?: boolean
}

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private showStepper = new Subject<boolean>();
  private completedSteps = new Subject<CompletedSteps>();
  private disabled = new Subject<boolean>();
  private isShowWelcomeMessge = new Subject<boolean>();
  private isExceptStepper = new Subject<boolean>();
  private isSetTimeOut = new Subject<boolean>();
  private isLogout = new Subject<boolean>();
  private leaseID = new Subject<string>();

  private _headerStepper = new Subject();

  private $preArrivalStepStatuses = new Subject<any>();

  constructor(
    private breadcrumbService: BreadcrumbService,
  ){}

  setShowStepper(isShownStepper: boolean){
    this.showStepper.next(isShownStepper);
  }

  getShowStepper() : Observable<boolean> {
    return this.showStepper.asObservable();
  }

  setCompletedSteps(completedSteps: CompletedSteps){
    this.completedSteps.next(completedSteps);
  }

  getCompletedSteps() : Observable<CompletedSteps> {
    return this.completedSteps.asObservable();
  }

  setDisabledStepper(disabled: boolean){
    this.disabled.next(disabled);
  }

  getDisabledStepper() : Observable<boolean> {
    return this.disabled.asObservable();
  }

  setShowWelcomeMessage(disabled: boolean){
    this.isShowWelcomeMessge.next(disabled);
  }

  getShowWelcomeMessage() : Observable<boolean> {
    return this.isShowWelcomeMessge.asObservable();
  }

  setExceptStepper(isExcept: boolean){
    this.isExceptStepper.next(isExcept);
  }

  getExceptStepper() : Observable<boolean> {
    return this.isExceptStepper.asObservable();
  }

  setSetTimeOut(isSetTimeOut: boolean){
    this.isSetTimeOut.next(isSetTimeOut);
  }

  getSetTimeOut() : Observable<boolean> {
    return this.isSetTimeOut.asObservable();
  }

  headerStepper(): Observable<any>{
    return this._headerStepper.asObservable();
  }

  showHeaderStepper(params: {show: boolean, currentStep?: number, steps?: any[]}){
    this._headerStepper.next(params);
  }

  hideHeaderStepper(){
    this._headerStepper.next({show: false});
  }

  setIsLogout(isLogout: boolean){
    this.isLogout.next(isLogout);
  }

  getIsLogout() : Observable<boolean> {
    return this.isLogout.asObservable();
  }

  breadcrumb(): Observable<BreadcrumbStatus | null>{
    return this.breadcrumbService.breadcrumb();
  }

  setBreadcrumb(status: BreadcrumbStatus | null){
    this.breadcrumbService.setBreadcrumb(status);
  }

  updateBreadcrumb(){
    this.breadcrumbService.updateBreadcrumb();
  }

  setCurrentBookingNumber(bookingNumber: string){
    this.breadcrumbService.setCurrentBookingNumber(bookingNumber)
  }

  preArrival(): Observable<any>{
    return this.$preArrivalStepStatuses.asObservable();
  }

  updatePreArrivalStepStatus(index: number, status: boolean){
    this.$preArrivalStepStatuses.next({
      index: index,
      status: status
    })
  }

  $leftMenu = new Subject();
  leftMenu(): Observable<any>{
    return this.$leftMenu.asObservable();
  }

  updateLeftMenus(menus: any[]){
    this.$leftMenu.next({
      menus: menus
    });
  }

  $reloadActionMenuStatus = new Subject();
  onReloadActionMenuStatus(): Observable<any>{
    return this.$reloadActionMenuStatus.asObservable();
  }

  reloadActionMenuStatus(){
    this.$reloadActionMenuStatus.next(true);
  }

}